import { render } from "./TicketDepartmentList.vue?vue&type=template&id=aae9e480"
import script from "./TicketDepartmentList.vue?vue&type=script&lang=js"
export * from "./TicketDepartmentList.vue?vue&type=script&lang=js"

import exportComponent from "/home/bazyaarc/sources/bazyaar-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__